import { createAction } from '@reduxjs/toolkit';
import { favoritesSlice } from './slice';

export const loadFavorites = createAction('favorites/loadFavorites');
export const addToFavorites = createAction<number>('favorites/addToFavorites');
export const removeFromFavorites = createAction<number>(
  'favorites/removeFromFavorites',
);

export const { setFavoriteIds, addFavoriteId, removeFavoriteId, setLoading } =
  favoritesSlice.actions;
